import React, { Component } from 'react';
import { Card } from 'react-md';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

import config from '../../../site-config';
import './ChartCard.scss';

// color palette https://coolors.co/

class ChartCard extends Component {
  constructor(props) {
    super(props);

    const tog = {};
    const allTime = this.props.bundleSummary.attack_cat_all_time;
    for (const k in allTime) {
      if (!allTime.hasOwnProperty(k)) continue;
      if (k === 'misconfiguration') {
        tog[k] = false;
      } else {
        tog[k] = true;
      }
    }
    this.state = {
      toggleState: tog,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ toggleState: nextProps.toggleState });
  }

  getLastMonthMult(timeUpdated) {
    const dateUpdated = new Date(parseInt(timeUpdated, 10) * 1000);
    const daysInMonth = new Date(
      dateUpdated.getFullYear(),
      dateUpdated.getMonth() + 1,
      0,
    ).getDate();
    return daysInMonth / dateUpdated.getDate();
  }

  render() {
    const { toggleState } = this.state;
    const catMapping = config.attacks.catMapping;
    const catColors = config.attacks.catColors;

    const data = this.props.bundleSummary.attack_cat_monthly;
    const allTime = this.props.bundleSummary.attack_cat_all_time;

    if (!data || !allTime) {
      return null;
    }

    data.forEach((o) => {
      for (const k in o) {
        if (o.hasOwnProperty(k)) {
          // Replace nulls with 0 so recharts can plot series without issue
          if (o[k] == null) o[k] = 0;
        }
      }
    });

    // Calculate multiplier for last month stats extrapolation
    const lastMonthMult = this.getLastMonthMult(
      this.props.bundleSummary.updated,
    );
    if (lastMonthMult > 1 && toggleState) {
      let lastMonthSum = 0;
      if (toggleState.device_spyware) {
        lastMonthSum += data[data.length - 1].device_spyware;
      }
      if (toggleState.captive_portal) {
        lastMonthSum += data[data.length - 1].captive_portal;
      }
      if (toggleState.misconfiguration) {
        lastMonthSum += data[data.length - 1].misconfiguration;
      }
      if (toggleState.corporate_appliance) {
        lastMonthSum += data[data.length - 1].corporate_appliance;
      }
      if (toggleState.unknown) {
        lastMonthSum += data[data.length - 1].unknown;
      }
      // Clip sum to 0
      lastMonthSum = Math.max(0, lastMonthSum);
      data[data.length - 1].projection = Math.round(
        lastMonthSum * (lastMonthMult - 1),
      );
    }

    // Update labels with human-readable names (modifiying local copy)
    const localData = [];
    data.forEach((o) => {
      const localMonth = {};
      for (const k in o) {
        if (o.hasOwnProperty(k)) {
          if (k === 'name') localMonth.name = o[k];
          if (!toggleState || toggleState[k] || k === 'projection') {
            localMonth[catMapping[k]] = o[k];
          }
        }
      }
      localData.push(localMonth);
    });

    const chartAreas = [];
    for (const k in allTime) {
      if (!allTime.hasOwnProperty(k)) continue;
      chartAreas.push(
        <Area
          type="monotone"
          dataKey={catMapping[k]}
          stackId="1"
          stroke={catColors[k]}
          fill={catColors[k]}
          dot={{ stroke: catColors[k], strokeWidth: 0.5 }}
          key={`chart-area-${k}`}
        />,
      );
    }

    return (
      <div className="chart-container md-grid mobile-fix">
        <h2 className="spying-breakdown">
          Eavesdropping attempts on your users
        </h2>
        <Card className="md-block-centered">
          <ResponsiveContainer width="100%" height={300}>
            <AreaChart
              data={localData}
              margin={{
                top: 20,
                right: 40,
                left: 0,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              {chartAreas}
              <Area
                type="monotone"
                dataKey={catMapping.projection}
                stackId="1"
                stroke="#D0D0D0"
                fill="#FBEBE0"
              />
            </AreaChart>
          </ResponsiveContainer>
        </Card>
      </div>
    );
  }
}

export default ChartCard;



// WEBPACK FOOTER //
// ./src/components/ChartCard/ChartCard.jsx